/* oem-catalog.js — OEM Catalog SPA */
(function() {
  'use strict';

  /* ═══ ANODIZATION DATA ═══ */
  var ANOD_COLORS = [
    { name: "Black",            voltage: 0,     hex: "#1a1a1a" },
    { name: "Silver",           voltage: 3.0,   hex: "#DFDFC8" },
    { name: "Champagne",        voltage: 8.0,   hex: "#D5B16D" },
    { name: "Dark Gold",        voltage: 11.5,  hex: "#CFA045" },
    { name: "Loft",             voltage: 17.0,  hex: "#4E2B19" },
    { name: "Aubergine",        voltage: 18.0,  hex: "#4A2F3F" },
    { name: "Plum",             voltage: 19.0,  hex: "#6549B1" },
    { name: "Purple",           voltage: 21.5,  hex: "#3B5AD0" },
    { name: "Deepsea",          voltage: 25.0,  hex: "#1A8CFF" },
    { name: "Sky Blue",         voltage: 33.5,  hex: "#85D4FF" },
    { name: "Ice Blue",         voltage: 40.5,  hex: "#B0E8FF" },
    { name: "Teal",             voltage: 44.5,  hex: "#6FA89D" },
    { name: "Sage",             voltage: 49.0,  hex: "#9EA68C" },
    { name: "Gilded Olive",     voltage: 56.0,  hex: "#E8F570" },
    { name: "Gold",             voltage: 63.0,  hex: "#F0D060" },
    { name: "Mango Gold Green", voltage: 68.0,  hex: "#FFB850" },
    { name: "Salmon",           voltage: 72.0,  hex: "#FF9070" },
    { name: "Rose",             voltage: 75.0,  hex: "#B85860" },
    { name: "Mauve",            voltage: 77.0,  hex: "#9F5A72" },
    { name: "Deep Pink",        voltage: 81.5,  hex: "#FF6090" },
    { name: "Orchid",           voltage: 84.0,  hex: "#D46BFF" },
    { name: "Azure",            voltage: 94.0,  hex: "#4B9AFF" },
    { name: "Lagoon",           voltage: 100.0, hex: "#15D3FF" },
    { name: "Seafoam",          voltage: 110.0, hex: "#51FFAD" }
  ];

  // ANOD_IRID_ROWS loaded on demand when 3D viewer initializes
  var ANOD_IRID_ROWS = [];
  var anodIridMap = new Map();

  /* ═══ PAGE ROUTING ═══ */
  var pages = ['landing','frets','bridge','nut','pickups','titanium','factory','order'];

  function goTo(pageId) {
    // Close mobile nav menu
    var navToggle = document.getElementById('catalog-nav-toggle');
    if (navToggle) navToggle.checked = false;

    // Hide all pages
    var allPages = document.querySelectorAll('.catalog-page');
    for (var i = 0; i < allPages.length; i++) {
      allPages[i].classList.remove('active');
    }
    // Show target
    var target = document.getElementById('page-' + pageId);
    if (target) target.classList.add('active');

    // Update nav
    var links = document.querySelectorAll('#catalog-nav-links a');
    for (var i = 0; i < links.length; i++) {
      links[i].classList.remove('current');
    }
    var navLink = document.getElementById('nav-' + pageId);
    if (navLink) {
      navLink.classList.add('current');
      // Update mobile active tab label
      var activeLabel = document.getElementById('catalog-nav-active-name');
      if (activeLabel) activeLabel.textContent = navLink.textContent;
    }

    // Update hash (preserve full path because main layout has <base href="/">)
    history.pushState(null, '', location.pathname + '#' + pageId);

    // Scroll to top
    window.scrollTo(0, 0);

    // Trigger anodization init when navigating to titanium, pause/resume render loop
    if (pageId === 'titanium') {
      tryAnodInit();
      if (anodEngine) {
        anodEngine.stopRenderLoop();
        anodEngine.runRenderLoop(function() { anodScene.render(); });
      }
    } else if (anodEngine) {
      anodEngine.stopRenderLoop();
    }
  }

  // Handle browser back/forward
  window.addEventListener('popstate', function() {
    var hash = location.hash.replace('#', '') || 'landing';
    goTo(hash);
  });


  /* ═══ CATALOG NAV SCROLL SYNC ═══ */
  // The fixed catalog nav sits on the bottom edge of the site header, which is in flow and
  // partly sticky, so its visible bottom changes while scrolling.
  function headerBottom() {
    var bottom = 0;
    document.querySelectorAll('.site-header .main-nav, .site-header .store-category-nav, .site-header .utility-bar').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height && r.bottom > bottom) bottom = r.bottom;
    });
    return Math.max(0, Math.round(bottom));
  }

  function initCatalogNavSync() {
    var navEl = document.getElementById('catalog-nav');
    if (!navEl) return;
    var frame = null;
    function sync() {
      frame = null;
      navEl.style.top = headerBottom() + 'px';
    }
    function schedule() { if (!frame) frame = window.requestAnimationFrame(sync); }
    sync();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCatalogNavSync);
  } else {
    initCatalogNavSync();
  }

  /* ═══ LIGHTBOX ═══ */
  function openLightbox(el) {
    var src = el.getAttribute('data-full');
    var cap = el.getAttribute('data-caption') || '';
    document.getElementById('lb-img').src = src;
    document.getElementById('lb-cap').textContent = cap;
    document.getElementById('lightbox').classList.add('active');
  }

  function closeLightbox() {
    document.getElementById('lightbox').classList.remove('active');
    document.getElementById('lb-img').src = '';
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeLightbox();
  });

  /* ═══ VARIANT TAB SWITCHER ═══ */
  function switchTab(boxId, panelId) {
    var box = document.getElementById(boxId);
    if (!box) return;
    var panels = box.querySelectorAll('.variant-panel');
    var btns = box.querySelectorAll('.variant-tabs button');
    for (var i = 0; i < panels.length; i++) { panels[i].classList.remove('active'); }
    for (var i = 0; i < btns.length; i++) { btns[i].classList.remove('active'); }
    var target = document.getElementById(panelId);
    if (target) target.classList.add('active');
    // find the button that triggers this panel
    for (var i = 0; i < btns.length; i++) {
      var oc = btns[i].getAttribute('onclick') || '';
      if (oc.indexOf("'" + panelId + "'") !== -1) { btns[i].classList.add('active'); break; }
    }
  }

  /* ═══ COMPARE HOVER ═══ */
  function compareEnter(activeId) {
    var container = document.getElementById('bridge-compare');
    var items = container.querySelectorAll('.ch-item');
    for (var i = 0; i < items.length; i++) { items[i].classList.remove('active'); }
    container.classList.add('has-active');
    document.getElementById(activeId).classList.add('active');
  }

  function compareLeave(activeId) {
    var container = document.getElementById('bridge-compare');
    container.classList.remove('has-active');
    document.getElementById(activeId).classList.remove('active');
  }

  /* ═══ MODE CYCLER ═══ */
  (function() {
    var modes = [
      { src: 'https://cdn.sharkguitars.com/assets/oem-catalog/shark_convertible_bridge_-__tremolomode.webp', cap: 'Tremolo Mode' },
      { src: 'https://cdn.sharkguitars.com/assets/oem-catalog/shark_convertible_bridge_-__hardtail_mode.webp', cap: 'Fixed Bridge Mode' },
      { src: 'https://cdn.sharkguitars.com/assets/oem-catalog/shark_convertible_bridge_-_maintenance_mode.webp', cap: 'Maintenance Mode' }
    ];
    var idx = 0;
    var img = document.getElementById('mc-img');
    var cap = document.getElementById('mc-cap');
    if (!img || !cap) return;
    var modeTimer = null;
    function startModeCarousel() {
      if (modeTimer) return;
      modeTimer = setInterval(function() {
        document.getElementById('mc-dot-' + idx).classList.remove('on');
        idx = (idx + 1) % modes.length;
        img.src = modes[idx].src;
        cap.textContent = modes[idx].cap;
        document.getElementById('mc-dot-' + idx).classList.add('on');
      }, 1500);
    }
    function stopModeCarousel() {
      if (modeTimer) { clearInterval(modeTimer); modeTimer = null; }
    }
    /* Only run carousel when bridge page is visible */
    var bridgePage = document.getElementById('page-bridge');
    if (bridgePage) {
      new MutationObserver(function() {
        if (bridgePage.classList.contains('active')) { startModeCarousel(); }
        else { stopModeCarousel(); }
      }).observe(bridgePage, { attributes: true, attributeFilter: ['class'] });
      if (bridgePage.classList.contains('active')) startModeCarousel();
    }
  })();

  /* ═══ X-RAY COMPARISON SLIDERS ═══ */
  (function() {
    function initXray(containerId, topId, handleId) {
      var container = document.getElementById(containerId);
      var top = document.getElementById(topId);
      var handle = document.getElementById(handleId);
      if (!container || !top || !handle) return;
      var dragging = false;
      function update(e) {
        var rect = container.getBoundingClientRect();
        var x = ((e.touches ? e.touches[0].clientX : e.clientX) - rect.left);
        x = Math.max(0, Math.min(x, rect.width));
        var pct = (x / rect.width) * 100;
        var rightClip = (100 - pct);
        top.style.clipPath = 'inset(0 ' + rightClip + '% 0 0)';
        handle.style.left = 'calc(' + pct + '% - 1.5px)';
      }
      handle.addEventListener('mousedown', function(e) { e.preventDefault(); dragging = true; });
      container.addEventListener('mousedown', function(e) { dragging = true; update(e); });
      document.addEventListener('mousemove', function(e) { if (dragging) update(e); });
      document.addEventListener('mouseup', function() { dragging = false; });
      handle.addEventListener('touchstart', function(e) { e.preventDefault(); dragging = true; }, { passive: false });
      container.addEventListener('touchstart', function(e) { dragging = true; update(e); }, { passive: true });
      document.addEventListener('touchmove', function(e) { if (dragging) update(e); }, { passive: true });
      document.addEventListener('touchend', function() { dragging = false; });
    }
    initXray('xray-frames', 'xray-frames-top', 'xray-frames-handle');
    initXray('xray-modules', 'xray-modules-top', 'xray-modules-handle');
  })();

  /* ═══ SCROLL HELPERS ═══ */
  function scrollToElement(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var navEl = document.getElementById('catalog-nav');
    var stickyHeader = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--store-sticky-header-h')) || 69;
    var navH = navEl && getComputedStyle(navEl).position === 'fixed' && getComputedStyle(navEl).top !== 'auto' ? navEl.offsetHeight : 0;
    var headerOffset = stickyHeader + navH + 85;
    var offsetPosition = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  }

  var scrollToProduct = scrollToElement;
  var scrollToSection = scrollToElement;

  /* ═══ STICKY TITLE BAR VISIBILITY + SCROLL SPY ═══ */
  (function() {
    var pageIds = ['frets','bridge','nut','pickups','titanium','factory'];

    function checkSticky() {
      for (var i = 0; i < pageIds.length; i++) {
        var pageEl = document.getElementById('page-' + pageIds[i]);
        var stickyEl = document.getElementById('sticky-' + pageIds[i]);
        if (!pageEl || !stickyEl) continue;

        if (!pageEl.classList.contains('active')) {
          stickyEl.classList.remove('visible');
          continue;
        }

        var heroBar = pageEl.querySelector('.page-hero-bar');
        if (!heroBar) continue;

        var heroBottom = heroBar.getBoundingClientRect().bottom;
        if (heroBottom < 150) {
          stickyEl.classList.add('visible');
        } else {
          stickyEl.classList.remove('visible');
        }
      }
    }

    /* Scroll spy: highlight active section in both parked nav and sticky nav */
    function updateActiveSection() {
      for (var i = 0; i < pageIds.length; i++) {
        var pageEl = document.getElementById('page-' + pageIds[i]);
        if (!pageEl || !pageEl.classList.contains('active')) continue;

        var navBar = document.getElementById('secnav-' + pageIds[i]);
        var stickyEl = document.getElementById('sticky-' + pageIds[i]);
        if (!navBar) continue;

        // Gather target IDs from the parked nav bar buttons only (canonical source)
        var navBtns = navBar.querySelectorAll('.psn-btn[onclick]');
        var targets = [];
        for (var b = 0; b < navBtns.length; b++) {
          var onclick = navBtns[b].getAttribute('onclick') || '';
          var m = onclick.match(/(?:scrollToSection|scrollToProduct)\('([^']+)'\)/);
          if (m && targets.indexOf(m[1]) === -1) targets.push(m[1]);
        }

        // Targets are already in DOM order from the nav buttons (top to bottom)

        // Find which section is currently in view
        // Walk from bottom to top, first one with top <= threshold wins
        // Default to first target when sticky bar is visible (page has been scrolled past hero)
        var activeId = targets.length > 0 ? targets[0] : null;
        var threshold = 250;

        // If scrolled to bottom of page, force last target active
        var atBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 80);
        if (atBottom && targets.length > 0) {
          activeId = targets[targets.length - 1];
        } else {
          for (var t = targets.length - 1; t >= 0; t--) {
            var secEl = document.getElementById(targets[t]);
            if (!secEl) continue;
            if (secEl.getBoundingClientRect().top <= threshold) {
              activeId = targets[t];
              break;
            }
          }
        }

        // Apply psn-active to matching buttons in both parked nav and sticky nav
        var containers = [navBar];
        if (stickyEl) {
          var stickyNav = stickyEl.querySelector('.pst-nav');
          if (stickyNav) containers.push(stickyNav);
        }
        for (var c = 0; c < containers.length; c++) {
          var btns = containers[c].querySelectorAll('.psn-btn');
          for (var j = 0; j < btns.length; j++) {
            var oc = btns[j].getAttribute('onclick') || '';
            var match = oc.match(/(?:scrollToSection|scrollToProduct)\('([^']+)'\)/);
            if (match && match[1] === activeId) {
              btns[j].classList.add('psn-active');
            } else {
              btns[j].classList.remove('psn-active');
            }
          }
        }
      }
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function() {
          checkSticky();
          updateActiveSection();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ═══ STICKY NAV CLONING ═══ */
  document.querySelectorAll('.page-section-nav').forEach(function(nav) {
    var pageId = nav.id.replace('secnav-', '');
    var stickyEl = document.getElementById('sticky-' + pageId);
    if (stickyEl) {
      var stickyNav = stickyEl.querySelector('.pst-nav');
      if (stickyNav) {
        stickyNav.innerHTML = nav.innerHTML;
      }
    }
  });

  /* ═══ ANODIZATION 3D PREVIEW ═══ */
  var anodMat, anodScene, anodEngine, anodProbe;

  function anodSelectColor(c, btnEl) {
    var key = c.voltage.toFixed(1);
    if (c.voltage === 0) {
      anodMat.iridescence.isEnabled = false;
    } else {
      var irid = anodIridMap.get(key);
      if (irid) {
        anodMat.iridescence.isEnabled = irid.enabled;
        anodMat.iridescence.intensity = irid.intensity;
        anodMat.iridescence.indexOfRefraction = irid.indexOfRefraction;
        anodMat.iridescence.minimumThickness = irid.minThicknessNm;
        anodMat.iridescence.maximumThickness = irid.maxThicknessNm;
      }
    }
    // Re-render probe once after color change
    if (anodProbe) anodProbe.refreshRate = BABYLON.RenderTargetTexture.REFRESHRATE_RENDER_ONCE;
    document.getElementById('anodColorName').textContent = c.name;
    document.querySelectorAll('#anodSelector .anod-swatch').forEach(function(b) { b.classList.remove('anod-active'); });
    if (btnEl) btnEl.classList.add('anod-active');
  }

  function anodInit() {
    var canvas = document.getElementById('anodCanvas');
    if (!canvas || !window.BABYLON) return;

    // Fetch anodization data, then build the scene
    fetch('/js/oem-catalog-anod-data.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        ANOD_IRID_ROWS = data;
        ANOD_IRID_ROWS.forEach(function(r) { anodIridMap.set(r.voltage.toFixed(1), r.iridescence); });
        buildAnodScene(canvas);
      })
      .catch(function() {});
  }

  function buildAnodScene(canvas) {
    // Prevent page scroll when mouse wheel is used inside the 3D viewer
    canvas.addEventListener('wheel', function(e) { e.preventDefault(); }, { passive: false });

    anodEngine = new BABYLON.Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true });
    anodScene = new BABYLON.Scene(anodEngine);
    anodScene.imageProcessingConfiguration.exposure = 1.0;
    anodScene.clearColor = new BABYLON.Color4(0.5, 0.5, 0.5, 1);

    var camera = new BABYLON.ArcRotateCamera("cam", -Math.PI / 2, Math.PI / 3, 4, BABYLON.Vector3.Zero(), anodScene);
    camera.attachControl(canvas, true);
    camera.wheelPrecision = 50;

    anodMat = new BABYLON.PBRMaterial("anodized", anodScene);
    anodMat.metallic = 0.95;
    anodMat.roughness = 0.15;
    anodMat.indexOfRefraction = 1.50;
    anodMat.metallicF0Factor = 0.62;
    anodMat.usePhysicalLightFalloff = true;

    anodMat.iridescence.isEnabled = true;
    anodMat.iridescence.intensity = 1.0;
    anodMat.iridescence.indexOfRefraction = 2.412;
    anodMat.iridescence.minimumThickness = 72.2;
    anodMat.iridescence.maximumThickness = 72.2;

    anodMat.environmentIntensity = 1.0;
    anodMat.directIntensity = 1.0;
    anodMat.specularIntensity = 1.0;

    var dt = new BABYLON.DynamicTexture("albedoTex", { width: 2, height: 2 }, anodScene, false);
    var ctx = dt.getContext();
    ctx.fillStyle = "#111111";
    ctx.fillRect(0, 0, 2, 2);
    dt.update();
    dt.wrapU = dt.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
    dt.hasAlpha = false;
    dt.level = 0.10;
    anodMat.albedoTexture = dt;
    anodMat.albedoColor = new BABYLON.Color3(1, 1, 1);

    var mesh = BABYLON.MeshBuilder.CreatePolyhedron("plate", { type: 8, size: 0.8 }, anodScene);
    var qFlip = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.X, Math.PI);
    var qSpin = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, -Math.PI / 6);
    mesh.rotationQuaternion = qSpin.multiply(qFlip);
    mesh.material = anodMat;

    var panelMat = new BABYLON.StandardMaterial("panelMat", anodScene);
    panelMat.emissiveColor = new BABYLON.Color3(1, 1, 1);
    panelMat.diffuseColor = new BABYLON.Color3(0, 0, 0);
    panelMat.specularColor = new BABYLON.Color3(0, 0, 0);
    panelMat.disableLighting = true;
    panelMat.backFaceCulling = false;

    var panels = [];
    var front = BABYLON.MeshBuilder.CreatePlane("pF", { width: 12, height: 8 }, anodScene);
    front.position = new BABYLON.Vector3(0, 0.5, -6);
    front.material = panelMat;
    panels.push(front);

    var top = BABYLON.MeshBuilder.CreatePlane("pT", { width: 12, height: 12 }, anodScene);
    top.position = new BABYLON.Vector3(0, 6, 0);
    top.rotation.x = Math.PI / 2;
    top.material = panelMat;
    panels.push(top);

    var right = BABYLON.MeshBuilder.CreatePlane("pR", { width: 8, height: 6 }, anodScene);
    right.position = new BABYLON.Vector3(6, 0.5, -1);
    right.rotation.y = -Math.PI / 2;
    right.material = panelMat;
    panels.push(right);

    var left = BABYLON.MeshBuilder.CreatePlane("pL", { width: 8, height: 6 }, anodScene);
    left.position = new BABYLON.Vector3(-6, 0.5, -1);
    left.rotation.y = Math.PI / 2;
    left.material = panelMat;
    panels.push(left);

    panels.forEach(function(p) { p.layerMask = 0x10000000; });

    anodProbe = new BABYLON.ReflectionProbe("probe", 1024, anodScene);
    anodProbe.refreshRate = BABYLON.RenderTargetTexture.REFRESHRATE_RENDER_ONCE;
    panels.forEach(function(p) { anodProbe.renderList.push(p); });

    anodMat.reflectionTexture = anodProbe.cubeTexture;
    anodMat.realTimeFiltering = true;
    anodMat.realTimeFilteringQuality = 32;

    var hemi = new BABYLON.HemisphericLight("hemi", new BABYLON.Vector3(0, 1, 0), anodScene);
    hemi.intensity = 0.15;
    hemi.diffuse = new BABYLON.Color3(1, 1, 1);
    hemi.specular = new BABYLON.Color3(0, 0, 0);

    anodEngine.runRenderLoop(function() { anodScene.render(); });
    window.addEventListener("resize", function() { anodEngine.resize(); });

    // Build rectangular color swatches
    var selector = document.getElementById('anodSelector');
    ANOD_COLORS.forEach(function(c, i) {
      var btn = document.createElement('div');
      btn.className = 'anod-swatch';
      btn.title = c.name;
      btn.style.background = c.hex;
      if (c.name === "Champagne") btn.classList.add('anod-active');
      btn.addEventListener('click', function() { anodSelectColor(c, btn); });
      selector.appendChild(btn);
    });

    // Default: Champagne
    anodSelectColor(ANOD_COLORS[2], null);

    // Hide loading indicator
    var loader = document.getElementById('anodLoader');
    if (loader) loader.classList.add('hidden');
  }

  // Lazy-load BabylonJS script, then initialize the 3D scene
  var anodInitDone = false;
  var babylonLoading = false;

  function loadBabylon(callback) {
    if (window.BABYLON) { callback(); return; }
    if (babylonLoading) return;
    babylonLoading = true;
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/babylonjs@9.26.2/babylon.js';
    script.onload = callback;
    script.onerror = function() { babylonLoading = false; };
    document.head.appendChild(script);
  }

  function tryAnodInit() {
    if (anodInitDone) return;
    var tiPage = document.getElementById('page-titanium');
    if (tiPage && (tiPage.classList.contains('active') || tiPage.offsetParent !== null)) {
      anodInitDone = true;
      anodObserver.disconnect();
      loadBabylon(function() { anodInit(); });
    }
  }

  // Watch for page visibility changes via class mutations
  var anodObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        tryAnodInit();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var tiPage = document.getElementById('page-titanium');
    if (tiPage) {
      anodObserver.observe(tiPage, { attributes: true });
      tryAnodInit();
    }
  });

  /* ═══ EXPOSE GLOBAL FUNCTIONS ═══ */
  window.goTo = goTo;
  window.openLightbox = openLightbox;
  window.closeLightbox = closeLightbox;
  window.switchTab = switchTab;
  window.compareEnter = compareEnter;
  window.compareLeave = compareLeave;
  window.scrollToSection = scrollToSection;
  window.scrollToProduct = scrollToProduct;

  /* ═══ INIT ═══ */
  // Handle initial load with hash
  (function() {
    var hash = location.hash.replace('#', '') || 'landing';
    if (pages.indexOf(hash) !== -1) {
      goTo(hash);
    }
  })();
})();
